import { useSelector } from "react-redux";
import mail from '/icons/mail.svg'
import instagram from '/icons/instagram.svg';
import facebook from '/icons/facebook.svg';
import logotype from "/images/logotype.svg";
import mail_white from '/icons/mail-white.svg'
import instagram_white from '/icons/instagram-white.svg';
import facebook_white from '/icons/facebook-white.svg';
import logotype_white from "/images/logotype-white.svg";
import "./Footer.scss";
import ColorModeToggle from "../components/ui/ColorModeToggle";
import { PreservedLink as Link } from "../components/ui/PreservedLink";
import { Phone } from "lucide-react";

function Footer() {
  const colorMode = useSelector((state) => state.ui.colorMode);

  return (
    <footer className="footer-container full-width py-20 pb-7 flex flex-col items-center">
      <div className="contained-width flex flex-col justify-between gap-20 md:flex-row">
        <div className="flex flex-col gap-4 w-full items-center md:w-1/4 md:items-start">
          <Link to="/">
            <img src={colorMode === 'dark' ? logotype_white : logotype} alt="Logo" />
          </Link>
          <p className="text-center md:text-left">
            Treatink lets you easily add your pet’s photo to veterinary recommended treats, supplements, and more - because every tail deserves a personal touch.
          </p>
          <ColorModeToggle />
        </div>

        <div className="flex flex-col gap-4 items-center w-full md:w-1/4 md:items-start">
          <div className="flex flex-col gap-2 items-center md:items-start">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/press-releases">Press Releases</Link>
            <Link to="/become-partner">Partner Application Form</Link>
            {/* <Link to="https://docs.google.com/forms/d/e/1FAIpQLSfX588hZcqXkXVVtSoy4Dlz_Gg1vwNV32tzGpsOD4Nw7cSs7A/viewform?usp=header">Clinic Inquiry Form</Link> */}
          </div>
        </div>

        <div className="flex flex-col max-w-full gap-4 items-center w-full md:w-1/4 md:items-start md:max-w-48">
          <div className="text-mid">Contact Us</div>
          <div className="flex flex-col flex items-start">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLScryAN3ZsZxW_8HzvtCcB07pIk8KGlLXFODcFOITvSwDsxQKg/viewform" target="_blank" className="mb-4 flex items-center gap-2">
              <img src={colorMode === 'dark' ? mail_white : mail} alt="" />
              <span>Contact Form</span>
            </a>
            <a href="https://www.instagram.com/pettreatink" target="_blank" className="mb-4 flex items-center gap-2">
              <img src={colorMode === 'dark' ? instagram_white : instagram} alt="" />
              <span>Instagram</span>
            </a>
            <a href="https://www.facebook.com/PetTreatink" target="_blank" className="mb-4 flex items-center gap-2">
              <img src={colorMode === 'dark' ? facebook_white : facebook} alt="" />
              <span>Facebook</span>
            </a>
            <a href="tel:(888) 890-0969" className="mb-4 flex items-center gap-2">
              <Phone size={18} color={colorMode === 'dark' ? 'white' : 'black'} />
              <span>(888) 890-0969</span>
            </a>
          </div>
        </div>
      </div>
      <p className="text-center mb-0 mt-10 md:mt-0">Copyright @Treatink 2025 All Rights Reserved</p>
    </footer>
  );
}

export default Footer;
